import React from "react";
import {Button} from "reactstrap";
import {IErrorClassifierGroup, IErrorClassifierKeyword} from "../../../store/errorClassifier/types";
import usePermissions from "../../../hooks/usePermissions";

interface TableErrorClassifierProps {
    data: IErrorClassifierGroup[]
    onUpdateGroud?: (groupId: number) => void
    onUpdateKeyword?: (keywordId: number) => void
}

interface TableErrorClassifierKeywordRowProps {
    keywords: IErrorClassifierKeyword[];
    onClickKeyword?: (keywordId: number) => void;
}

const TableErrorClassifierKeywordRow: React.FC<TableErrorClassifierKeywordRowProps> = ({keywords, onClickKeyword}) => {
    return (
        <div className="d-flex border-top border-primary-subtle p-2 px-3">
            <div className="d-flex align-items-start gap-2 flex-wrap">
                {keywords.map((keyword) => (
                    <Button key={keyword.id} onClick={() => onClickKeyword?.(keyword.id)}
                            color="light" size="sm">{keyword.name}</Button>
                ))}
            </div>
        </div>
    )
}

const TableErrorClassifierDefaultRow = () => {
    return (
        <div className="d-flex border-top border-secondary p-2 px-3">
            <div className="d-flex gap-2 flex-wrap">
                <span className="d-flex align-items-center text-secondary lh-1 fst-italic">
                    Default group for unmatched responses
                </span>
            </div>
        </div>
    )
}

const TableErrorClassifier: React.FC<TableErrorClassifierProps> = ({data, onUpdateGroud, onUpdateKeyword}) => {
    const {hasPermission} = usePermissions();

    const handleUpdateGroupClick = (groupId: number) => {
        if (onUpdateGroud) onUpdateGroud(groupId);
    }

    const handleUpdateKeywordClick = (keywordId: number) => {
        if (onUpdateKeyword && hasPermission("update-error-classifier")) onUpdateKeyword(keywordId);
    }

    return (
        <div>
            <div className="d-grid overflow-auto border border-secondary rounded-3 shadow"
                 style={{gridTemplateColumns: 'auto 1fr'}}>
                <div
                    className="d-flex align-items-center gap-1 bg-light border-end border-secondary text-secondary fst-italic fw-bold p-2 pe-3">
                    <i className="bx bxs-key"></i>
                    Group
                </div>
                <div className="d-flex align-items-center gap-1 fw-bold text-secondary fst-italic p-2 px-3">
                    <i className="bx bx-coin-stack"></i>
                    Keywords
                </div>
                {data.map((group) => (
                    <React.Fragment key={group.id}>
                        <div className="bg-light fw-bold border-top border-end border-secondary p-2">
                            <div className="d-flex gap-3 justify-content-between align-items-center">
                                <div className="d-flex align-items-center gap-2">
                                    <span className="rounded-circle flex-shrink-0"
                                          style={{width: "6px", height: "6px", backgroundColor: group.color}}></span>
                                    <span>{group.name}</span>
                                </div>
                                {hasPermission("update-error-classifier") &&
                                    <Button onClick={() => handleUpdateGroupClick(group.id)} color="light" size="sm">
                                        <i className="bx bx-edit"></i>
                                    </Button>}
                            </div>
                        </div>
                        {group.nostatus_group ? <TableErrorClassifierDefaultRow/> :
                            <TableErrorClassifierKeywordRow keywords={group.keywords}
                                                            onClickKeyword={handleUpdateKeywordClick}/>}
                    </React.Fragment>
                ))}
            </div>
        </div>
    )
}

export default TableErrorClassifier;